import DOMPurify from 'dompurify';

/**
 * Sanitize HTML string to prevent XSS attacks
 * @param {string} dirty - Potentially unsafe HTML string
 * @returns {string} Sanitized HTML string
 */
export const sanitizeHTML = (dirty) => DOMPurify.sanitize(dirty);

/**
 * Escape HTML entities to prevent XSS when inserting text
 * @param {string} str - String to escape
 * @returns {string} Escaped string safe for innerHTML
 */
export const escapeHTML = (str) => {
    if (typeof str !== 'string') return '';
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
};
